import React, { useEffect, useState } from 'react';
import { Form, Modal, ModalBody, ModalHeader, Input, Button, FormGroup, Label } from 'reactstrap';
import axios from 'axios';
import { messageTemplate } from './template';
import { useDispatch, useSelector } from 'react-redux';
import createCustomerSelector from 'store/customer/selector';
import Select from 'react-select';
import createTemplateSelector from 'store/template/selector';
import { openMessageModal } from 'store/customer/actions';

const MessageModal = () => {
    const dispatch = useDispatch();
    const templateSelector = useSelector(createTemplateSelector);
    const { allSMSTemplate } = templateSelector;
    const customerSelector = useSelector(createCustomerSelector);
    const { allCustomersData, isOpenMessageModal } = customerSelector;
    const [to, setTo] = useState('');
    const [overdue_invoice, setOverDueInvoice] = useState('');
    const [message, setMessage] = useState(null);
    const [customMessage, setCustomMessage] = useState('');
    const [isOtherMessage, setIsOtherMessage] = useState(false);
    const [customNumber, setCustomNumber] = useState('');
    const [isOtherNumber, setIsOtherNumber] = useState(false);
    const [showInvoice, setShowInvoice] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [customerOption, setCustomerOption] = useState([]);

    const toggle = () => {
        dispatch(openMessageModal(!isOpenMessageModal));
        setIsOtherMessage(false);
        setIsOtherNumber(false);
        setCustomMessage('');
        setCustomNumber('');
    };

    const handleChangeMessage = (event) => {
        const messageType = event.target.value;

        if (messageType === 'Custom Message') {
            setIsOtherMessage(true);
            const otherTemplate = messageTemplate.find(template => template.name === 'Custom Message');
            setMessage(otherTemplate || { name: 'Custom Message', title: '', message: '', customer_support: '' });
        } else if (messageType) {
            setIsOtherMessage(false);
            const filterMessage = allSMSTemplate.find(template => messageType === template.name);
            setMessage(filterMessage);
            setOverDueInvoice('');
            const relevantMessageTypes = ['Suspended', 'Suspend_Pending', 'Removal_Scheduled'];
            if (relevantMessageTypes.includes(messageType)) {
                setShowInvoice(true);
            } else {
                setShowInvoice(false);
            }
        }
    };

    const handleChangeSelected = (value) => {
        if (value.value === 'Other') {
            setIsOtherNumber(true);
            setTo('');
        } else {
            setIsOtherNumber(false);
            setTo(value.value);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            setLoading(true);
            setError('');
            const payload = {
                to: isOtherNumber ? customNumber : to,
                message: isOtherMessage ? { ...message, message: customMessage } : message,
                overdue_invoice
            };
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/twilio/sendSMS`, payload);
            setTo('');
            setMessage(null);
            setCustomMessage('');
            setCustomNumber('');
            setOverDueInvoice('');
            setShowInvoice(false);
            toggle();
        } catch (err) {
            setError('Failed to send message. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchedOptions = allCustomersData.map(item => ({
            value: item.phone_number,
            label: `${item.name}`,
        }));
        setCustomerOption([...fetchedOptions, { value: 'Other', label: 'Other' }]);
    }, [allCustomersData]);

    return (
        <Modal isOpen={isOpenMessageModal} toggle={toggle}>
            <ModalHeader toggle={toggle}>Send Message</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="to">To</Label>
                        <div className='mb-4'>
                            <Select
                                onChange={handleChangeSelected}
                                options={customerOption}
                                placeholder="Select Customer"
                                className='text-capitalize'
                            />
                        </div>
                        {isOtherNumber && (
                            <div className="mt-2">
                                <Label for="customNumber">Enter Number</Label>
                                <Input
                                    type="text"
                                    id="customNumber"
                                    placeholder="Enter Phone Number"
                                    value={customNumber}
                                    onChange={(e) => setCustomNumber(e.target.value)}
                                />
                            </div>
                        )}
                    </FormGroup>
                    <FormGroup>
                        <Label for="message">Message Type</Label>
                        <Input
                            type="select"
                            name="message"
                            id="message"
                            placeholder="Enter your message"
                            onChange={handleChangeMessage}
                        >
                            <option>--Select--</option>
                            {messageTemplate.map((template) => {
                                return <option>{template.name}</option>
                            })}
                        </Input>
                        {isOtherMessage && (
                            <div className="mt-2">
                                <Label for="customMessage">Message</Label>
                                <Input
                                    type="textarea"
                                    id="customMessage"
                                    placeholder="Type your message here..."
                                    maxLength={120}
                                    value={customMessage}
                                    onChange={(e) => setCustomMessage(e.target.value)}
                                />
                                <div className="text-right small text-muted">
                                    {customMessage.length}/120 characters
                                </div>
                            </div>
                        )}
                    </FormGroup>
                    {showInvoice && <FormGroup>
                        <Label>Invoice Amount ($)</Label>
                        <Input
                            type="text"
                            placeholder="Overdue Invoice"
                            value={overdue_invoice}
                            onChange={(e) => setOverDueInvoice(e.target.value)}
                        />
                    </FormGroup>}
                    {error && <p className="text-danger">{error}</p>}
                    <div className="text-right">
                        <Button
                            color="primary"
                            disabled={
                                (isOtherNumber ? !customNumber : !to) ||
                                (isOtherMessage ? !customMessage : !message) ||
                                loading
                            }
                        >
                            {loading ? 'Sending...' : 'Send Message'}
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default MessageModal;
